import { z } from 'zod';

import { BasePType } from './base';
import { NestedSecondColumn } from './primary-footer';
import { PrimaryFooterColumn } from './primary-footer-column';

export const SubFooter = BasePType.extend({
  type: z.enum(['subFooter']),
  nestedFirstColumn: z.array(PrimaryFooterColumn),
  nestedSecondColumn: NestedSecondColumn,
});

export type SubFooter = z.infer<typeof SubFooter>;
